import { render, staticRenderFns } from "./ats-cv.vue?vue&type=template&id=5d228f34&scoped=true"
import script from "./ats-cv.vue?vue&type=script&lang=ts"
export * from "./ats-cv.vue?vue&type=script&lang=ts"
import style0 from "./ats-cv.vue?vue&type=style&index=0&id=5d228f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d228f34",
  null
  
)

export default component.exports